import { Form, Modal, ModalProps, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSubstitueAssignation } from "./queries"
import { useEffect, useState } from "react"
import TextArea from "antd/es/input/TextArea"

interface Props extends ModalProps {
  data?: string
  onClose: () => void
}
const SubstituteAssignationModal: React.FC<Props> = ({
  data: id,
  ...props
}) => {
  const { t } = useTranslation()
  const [comment, setComment] = useState<string | undefined>()
  const { mutate, isLoading } = useSubstitueAssignation({
    meta: {
      type: "create",
      entity: t("assignations.substitution_one"),
      context: "female",
      count: 1,
    },
  })

  const onSubmit = () => {
    mutate(
      {
        assignationId: id!,
        comment,
      },
      {
        onSettled() {
          props.onClose()
        },
      }
    )
  }

  useEffect(() => {
    !props.open && setComment(undefined)
  }, [props.open])

  return (
    <Modal
      title={t("assignations.substitution_request_one")}
      onOk={onSubmit}
      okText={t("global.confirm")}
      confirmLoading={isLoading}
      onCancel={props.onClose}
      cancelText={t("global.cancel")}
      {...props}
    >
      <Form layout="vertical">
        <Form.Item label={t("labels.comment")}>
          <TextArea
            rows={4}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </Form.Item>
        <Typography.Text>
          {t("assignations.substitution_confirmation")}
        </Typography.Text>
      </Form>
    </Modal>
  )
}

export default SubstituteAssignationModal
